export type VideoDetails = {
   url: string;
   caption: string;
}

const videoData: Array<VideoDetails> = [
   {
      url: "LZnQ2nR0jy0",
      caption: "2023 RCS Fridays at One"
   },
   {
      url: "FsYzUhflJj4",
      caption: "2020 Skye Recital"
   },
   {
      url: "qEyl8yrLSeE",
      caption: "2019 SIYPC"
   },
   {
      url: "UIF5Do4jXL4",
      caption: "2019 Lanark"
   },
   {
      url: "-LzVGy1Nqig",
      caption: "2018 Lanark"
   },
]
export default videoData;